// IMPORTACIONES
import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";

// FUNCION PRINCIPAL
export default function TextFieldInput(props) {
  const {
    label,
    id,
    varianField,
    defaultValue,
    placeholder,
    disabled,
    value,
    onChange,
    onBlur,
    sm,
    md,
    onClick,
    size,
    fullWidth,
    color,
  } = props;
  // vista
  return (
    <>
      {/** <Grid item xs={12} sm={sm === null ? 12 : sm} md={md}>
            <MuiThemeProvider>
                {
                    label !== undefined ? (
                        <InputLabel color="primary" style={{color:"black",size:"small",fontSize: 12, fontWeight: 'medium'}}>
                            {label}
                        </InputLabel>
                    ) : null
                }*/}
      <TextField
        fullWidth={fullWidth}
        id={id}
        margin="normal"
        label={label}
        variant={varianField}
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onClick={onClick}
        size={size}
        color={color}
        sm={sm}
        md={md}
      />
    </>
  );
}
TextFieldInput.propTypes = {
  label: PropTypes.node,
  id: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  sm: PropTypes.number,
  md: PropTypes.number,
  placeholder: PropTypes.string,
};
